import React, { Component } from 'react';
import DraftsTable from './components/DraftsTable';

class DraftsCard extends Component {

  render() {
    return <DraftsTable />
  }

}

export default DraftsCard;
